/**
 * Takes a string, capitalizes the first character of every word and lowercases the rest.
 * E.g. `hElLo wORld` -> `Hello World`.
 *
 * Note: the argument `string` was marked as `unknown` during the Typescript rewrite because the
 * existing tests indicate that this function expects to receive various types of invalid input
 * that ultimately get silently normalized to an empty string.
 * @todo: check callers for any static/runtime type mismatches for the first argument, fix and change the type to `string`.
 *
 * @param {string} string The string to capitalize
 * @param {boolean} keepOtherCharCase optional boolean to indicate if we should lowercase the rest
 */
export const capitalize = (string: unknown, keepOtherCharCase = false): string => {
  if (!string || typeof string !== 'string') return '';

  return string.replace(/([^\W_]+[^\s-]*) */g, (word) => {
    const firstLetter = word.charAt(0).toUpperCase();
    const otherLetters = keepOtherCharCase ? word.substr(1) : word.substr(1).toLowerCase();
    return firstLetter + otherLetters;
  });
};

/**
 * Accepts a string and in case its length is greater than `maxLength`,
 * it truncates the string, adding an ellipsis at the end or beginning.
 * @param stringValue The initial string
 * @param maxLength The maximum length the end string should have
 * @param ellipsis The string representing the ellipsis
 * @param putEllipsisBefore if true put the ellipsis before
 */
// eslint-disable-next-line func-params-args/func-params
export const limitLength = (
  stringValue: string,
  maxLength: number,
  ellipsis = '…',
  putEllipsisBefore?: boolean,
): string => {
  if (stringValue.length <= maxLength) {
    return stringValue;
  }

  if (putEllipsisBefore === true) {
    return ellipsis + stringValue.substring(stringValue.length - maxLength + ellipsis.length);
  }

  return stringValue.substring(0, maxLength - ellipsis.length) + ellipsis;
};
